import "../styles/orderDetails.css"

import { motion } from "framer-motion"
import client from "../asstes/dashboard/client.png"

import React, { useState, useEffect } from 'react';

import exit from "../asstes/dashboard/exit.png"

import { getDatabase, ref, set, push, get } from "firebase/database";


import payment from "../asstes/payment.png"

import location from "../asstes/Location.png"
import size from "../asstes/size.png"
import weight from "../asstes/weight.png"
import truck from "../asstes/truckImg.png"
import palette from "../asstes/palette.png"




function OrderDetails({order , close }) {



    const [transp , setTransp] = useState(null);
    
    const [transDetailShown , setTransDetailShown] = useState(false);
    
    const getOrderTransporter = async ()=> {


            const db = getDatabase();
            const shipments = ref(db, 'Transporter');
            let ss = await get(shipments);
    
            const data = ss.val();
            const list = Object.entries(data)
            for (let i = 0; i < list.length; i++) {
                let element = list[i];


                if (element[0] == order.transporter_id) {

                    setTransp({ id: element[0], name: element[1].name, city: element[1].city, location: element[1].location, email: element[1].email, payment_method: element[1].payment_method, phone: element[1].phone, state: element[1].status, vehicle_type: element[1].vehicle, date: "12/12/2023" })
                    
                    return element;
                }
            }
    
            return "cc";
        
    }


    useEffect(() => {

        console.log(order)
        getOrderTransporter();

        

    })

    return (
        order != null ?
        <motion.div
            className="orders-details"
            id="orders-details"
            initial={{ opacity: 0 }}
            animate={transDetailShown ? { opacity: 1, transition: { delay: 2 } , zIndex:6 } : { opacity: 1, transition: { delay: 2 }, zIndex : 4 }}
        >

                <div className="close-btn"
                    onClick={()=> {
                        close(false)
                    }}
                >
                    
                    <img src={exit} alt="" />
                    </div>
            <div className="top-orders-details">
                <div className="orders-infos">

                    
                    <p className="">Commande {order.id}</p>
                    <p>Description :</p>
                    <p className="">{order.description}</p>
                </div>
                <div className="orders-infos">
                    <div className="order-info-header">
                        <div className="order-info-img">
                            <img src={client} alt="" />
                        </div>

                        <p>Client</p>
                    </div>

                    <div className="order-info-corps">
                        <p>{order.client}</p>
                    </div>
                </div>
                <div className="orders-infos">
                    <div className="order-info-header">
                        <div className="order-info-img">
                            <img className="mirror" src={location} alt="" />
                        </div>

                        <p>Lieu De Chargement</p>
                    </div>

                    <div className="order-info-corps">
                        <p className="ellipsis">{order.from}</p>
                    </div>
                </div>
                <div className="orders-infos">
                    <div className="order-info-header">
                        <div className="order-info-img">
                            <img  src={location} alt="" />
                        </div>

                        <p>Lieu De Décharge</p>
                    </div>

                    <div className="order-info-corps">
                        <p className="ellipsis">{order.to}</p>
                    </div>
                </div>
                <div className="orders-infos flex flex-column">
                    <div className="order-info-header">
                        <div className="order-info-img">
                            <img src={palette} alt="" />
                        </div>

                        <p>Nombre D'unités</p>

                        
                    </div>

                    <div className="order-info-corps">
                        <p>{order.palette_number != "" ? order.palette_number : "0"}</p>
                    </div>

                    <div className="order-info-header">
                        <div className="order-info-img">
                            <img src={palette} alt="" />
                        </div>

                        <p>Description D'unités</p>

                        
                    </div>

                    <div className="order-info-corps">
                        <p>{order.palette_number != "" ? order.units_description : "0"}</p>
                    </div>

                    
                </div>

            </div>
            <div className="bottom-orders-details">
                <div className="orders-infos">
                    <p>Etat de Commande</p>

                    <motion.p className="state-container">
                        <div  className={order.state === "w" ? "stat-circle bkYellow" :order.state === "c" ? "stat-circle bkBlue" :order.state === "d"? "stat-circle bkgreen" : "stat-circle bkred"} >
                            <p>{order.state.replace("cn", "-")}</p>
                        </div>
                    </motion.p>
                    {
                        order.state === "w" ?
                    <p className="big-text">En Attente</p>
                    :
                    order.state === "c" ?
                    <p className="big-text">Confirmé</p>
                    :

                    order.state === "d" ?
                    <p className="big-text">Livré</p>
                    :
                    <p className="big-text">Annulé</p>
                    
                    }
                </div>
                <div className="orders-infos">
                    <div className="order-info-img">
                        <img src={truck} alt="" />
                    </div>
                    <p>Véhicule</p>
                    <div className="order-info-corps">
                        <p>{order.vehicle_type}</p>
                    </div>
                </div>
                <div className="orders-infos">
                    <div className="order-info-img">
                        <img src={payment} alt="" />
                    </div>
                    <p>Methode De Payment</p>
                    <div className="order-info-corps">
                        <p>{order.paiment}</p>
                    </div>
                </div>
                <div className="orders-infos">
                    <div className="order-info-img">
                        <img src={size} alt="" />
                    </div>
                    <p>Taille D'expédition</p>
                    <div className="order-info-corps">
                        <p>{order.size}</p>
                    </div>

                </div>
                <div className="orders-infos">
                    
                    <div className="order-info-img">
                        <img src={weight} alt="" />
                    </div>
                    <p>Poids D'expédition</p>

                    <div className="order-info-corps">
                        <p>{order.weight}</p>
                    </div>
                </div>
            </div>
            
        </motion.div>
        :
        <div></div>
    );
}

export default OrderDetails;